/* import { IData } from '../../app/Macro2/components/graphicalResults/HydraulicResults/HydraulicVertical'; */
import { IColumnType } from './Table';
import { TableRowCell } from './TableRowCell';

interface Props<T> {
    data: T[];
    columns: IColumnType<T>[];
}

export function TableRow<T>({ data, columns }: Props<T>): JSX.Element {
    return (
        <>
            {data.map((item, itemIndex) => {
                let valueFullRow = (item as any).valueFullRow;
                if (valueFullRow) {
                    return (
                        <tr>
                          {/*   <td>{(item as IData).label}</td>
                            <td colSpan={4}>{(item as IData).value}</td> */}
                        </tr>
                    );
                } else
                    return (
                        <tr key={`table-body-${itemIndex}`}>
                            {columns.map((column, columnIndex) => {
                                return <TableRowCell key={`table-row-cell-${columnIndex}`} item={item} column={column} />;
                            })}
                        </tr>
                    );
            })}
        </>
    );
}
